function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip-path"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_276",
  "data-name": "Path 276",
  d: "M15,0A15,15,0,0,0,30-15,15,15,0,0,0,15-30,15,15,0,0,0,0-15,15,15,0,0,0,15,0Z",
  fill: "none",
  clipRule: "evenodd"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "clip-path-2"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_275",
  "data-name": "Path 275",
  d: "M-20,319H300V-249H-20Z",
  fill: "none"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "clip-path-3"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_279",
  "data-name": "Path 279",
  d: "M9-17a2,2,0,0,0,2-2,2,2,0,0,0-2-2,2,2,0,0,0-2,2A2,2,0,0,0,9-17Z",
  fill: "none",
  clipRule: "evenodd"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "clip-path-5"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_282",
  "data-name": "Path 282",
  d: "M21-17a2,2,0,0,0,2-2,2,2,0,0,0-2-2,2,2,0,0,0-2,2A2,2,0,0,0,21-17Z",
  fill: "none",
  clipRule: "evenodd"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "clip-path-7"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_285",
  "data-name": "Path 285",
  d: "M15-7.379c3.866,0,8-2.686,8-6,0-.847-16-.81-16,0C7-10.065,11.134-7.379,15-7.379Z",
  fill: "none",
  clipRule: "evenodd"
})));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Group_1621",
  "data-name": "Group 1621",
  transform: "translate(0 30)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_1406",
  "data-name": "Group 1406",
  clipPath: "url(#clip-path)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_1405",
  "data-name": "Group 1405",
  clipPath: "url(#clip-path-2)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_274",
  "data-name": "Path 274",
  d: "M-5-35H35V5H-5Z",
  fill: "#009dca"
}))), /*#__PURE__*/React.createElement("g", {
  id: "Group_1408",
  "data-name": "Group 1408",
  clipPath: "url(#clip-path-3)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_1407",
  "data-name": "Group 1407",
  clipPath: "url(#clip-path-2)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_277",
  "data-name": "Path 277",
  d: "M2-26H16v14H2Z",
  fill: "#fff"
}))), /*#__PURE__*/React.createElement("g", {
  id: "Group_1410",
  "data-name": "Group 1410",
  clipPath: "url(#clip-path-5)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_1409",
  "data-name": "Group 1409",
  clipPath: "url(#clip-path-2)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_280",
  "data-name": "Path 280",
  d: "M14-26H28v14H14Z",
  fill: "#fff"
}))), /*#__PURE__*/React.createElement("g", {
  id: "Group_1412",
  "data-name": "Group 1412",
  clipPath: "url(#clip-path-7)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_1411",
  "data-name": "Group 1411",
  clipPath: "url(#clip-path-2)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_283",
  "data-name": "Path 283",
  d: "M2-19H28V-2.379H2Z",
  fill: "#fff"
}))));

var SvgIconProfile = function SvgIconProfile(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIconProfile, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon-profile.523553e7.svg";
export { ForwardRef as ReactComponent };